'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Thumb = function (_React$Component) {
    _inherits(Thumb, _React$Component);

    function Thumb() {
        _classCallCheck(this, Thumb);

        var _this = _possibleConstructorReturn(this, (Thumb.__proto__ || Object.getPrototypeOf(Thumb)).apply(this, arguments));

        _this.componentWillUnmount = function () {
            _this.removeDocumentMouseMoveListener();
            _this.removeDocumentMouseUpListener();
            _this.removeDocumentTouchEndListener();
            _this.removeDocumentTouchMoveListener();
        };
        /**
         * @return {Object} inline styles
         */
        _this.getStyle = function () {
            var perc = (_this.props.percentage || 0) * 100;
            var style = {
                position: 'absolute',
                left: perc + '%'
            };
            return style;
        };
        _this.addDocumentMouseMoveListener = function () {
            _this.removeDocumentMouseMoveListener();
            _this.node.ownerDocument.addEventListener('mousemove', _this.handleMouseMove);
        };
        _this.addDocumentMouseUpListener = function () {
            _this.removeDocumentMouseUpListener();
            _this.node.ownerDocument.addEventListener('mouseup', _this.handleMouseUp);
        };
        _this.addDocumentTouchMoveListener = function () {
            _this.removeDocumentTouchMoveListener();
            _this.node.ownerDocument.addEventListener('touchmove', _this.handleTouchMove);
        };
        _this.addDocumentTouchEndListener = function () {
            _this.removeDocumentTouchEndListener();
            _this.node.ownerDocument.addEventListener('touchend', _this.handleTouchEnd);
        };
        _this.handleMouseDown = function () {
            _this.props.onDragStart();
            _this.addDocumentMouseMoveListener();
            _this.addDocumentMouseUpListener();
        };
        _this.handleMouseUp = function () {
            _this.removeDocumentMouseMoveListener();
            _this.removeDocumentMouseUpListener();
        };
        _this.handleMouseMove = function (event) {
            _this.props.onThumbDrag(event, _this.props.type);
        };
        _this.handleTouchStart = function () {
            _this.props.onDragStart();
            _this.addDocumentTouchEndListener();
            _this.addDocumentTouchMoveListener();
        };
        _this.handleTouchMove = function (event) {
            _this.props.onThumbDrag(event, _this.props.type);
        };
        _this.handleTouchEnd = function () {
            _this.removeDocumentTouchMoveListener();
            _this.removeDocumentTouchEndListener();
        };
        _this.handleKeyDown = function (event) {
            _this.props.onDragStart();
            _this.props.onThumbKeyDown(event, _this.props.type);
        };
        return _this;
    }

    _createClass(Thumb, [{
        key: 'removeDocumentMouseMoveListener',
        value: function removeDocumentMouseMoveListener() {
            this.node.ownerDocument.removeEventListener('mousemove', this.handleMouseMove);
        }
    }, {
        key: 'removeDocumentMouseUpListener',
        value: function removeDocumentMouseUpListener() {
            this.node.ownerDocument.removeEventListener('mouseup', this.handleMouseUp);
        }
    }, {
        key: 'removeDocumentTouchMoveListener',
        value: function removeDocumentTouchMoveListener() {
            this.node.ownerDocument.removeEventListener('touchmove', this.handleTouchMove);
        }
    }, {
        key: 'removeDocumentTouchEndListener',
        value: function removeDocumentTouchEndListener() {
            this.node.ownerDocument.removeEventListener('touchend', this.handleTouchEnd);
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var style = this.getStyle();
            return _react2.default.createElement("div", { className: this.props.className.thumbContainer, ref: function ref(node) {
                    _this2.node = node;
                }, style: style }, _react2.default.createElement("div", { "aria-labelledby": this.props.ariaLabelledby, "aria-controls": this.props.ariaControls, "aria-valuemax": this.props.maxValue, "aria-valuemin": this.props.minValue, "aria-valuenow": this.props.value, className: this.props.className.thumb, draggable: "false", onKeyDown: this.handleKeyDown, onMouseDown: this.handleMouseDown, onTouchStart: this.handleTouchStart, onKeyUp: this.props.onDragEnd, onMouseUp: this.props.onDragEnd, onTouchEnd: this.props.onDragEnd, onTouchCancel: this.props.onDragEnd, role: "slider", tabIndex: "0" }));
        }
    }]);

    return Thumb;
}(_react2.default.Component);

exports.default = Thumb;

Thumb.propTypes = {
    ariaLabelledby: _propTypes2.default.string,
    ariaControls: _propTypes2.default.string,
    className: _propTypes2.default.objectOf(_propTypes2.default.string).isRequired,
    formatLabel: _propTypes2.default.func,
    maxValue: _propTypes2.default.number,
    minValue: _propTypes2.default.number,
    onThumbDrag: _propTypes2.default.func.isRequired,
    onThumbKeyDown: _propTypes2.default.func.isRequired,
    percentage: _propTypes2.default.number.isRequired,
    type: _propTypes2.default.string.isRequired,
    value: _propTypes2.default.number.isRequired
};
//# sourceMappingURL=Thumb.js.map


// WEBPACK FOOTER //
// ./node_modules/luna-react/dist/components/Slider/Thumb.js